/* eslint-disable no-lonely-if */
/* eslint-disable no-else-return */
/* eslint-disable func-names */
import { Window } from '../../00_IMMEDIATE/Window';
import { Window_FillRateFallback } from './Window_FillRateFallback';
import OMT_UI_SquareButton, { BUTTONCOLOURS, BUTTONSTATE } from '../../OMT_UI/OMT_UI_SquareButton';
import SpinningWheel from '../Daily/SpinningWheel';

/**
 * Window Class for the daily wheel reward
 */
class Window_DailyWheel extends Window {
  /**
   * cosntructor
   * @param {Object} parent
   * @param {Object} config
   */
  constructor(parent, config) {
    super(parent);

    this._worldState = config.worldState;
    this._moreMoneyMode = config.asMoreMoney;
    this._isAdFallback = config.isAdFallback === true;
    this._showCloseButtonInitially = config.showCloseButton !== undefined ? config.showCloseButton === true : true;

    this.y = this._worldState ? -50 : -50 + G.WindowMgr.Constants.WorldVerticalOffset;
    if (!this._worldState) this._coinBar = this.add(new G.CoinBar(0, -300, true));

    this._incentivised = game.incentivised();
    this._premium = false;

    this._initWheel();
    // set regular or premium rewards
    if (this._isAdFallback || (!this._moreMoneyMode && G.saveState.data.freeSpin)) this._changeToRegular();
    else this._changeToPremium(false);
    this.add(this._activeWheel);
    this._initPrizeBanner();
    this._initButtons();
    this._initPostSpinElements();

    this._giftGroup = this.add(game.make.group());
    this._giftGroup.y = 80;

    this._attachListenersToWheel(this._activeWheel);

    this._startInitialAnimation();
  }

  /**
   * start the intro animation
   */
  _startInitialAnimation() {
    this._freeStopBtn.visible = true;
    this._freeStopBtn.alpha = 0;
    this._activeWheel.fillWheel();
    this._activeWheel.enterTheWheel();
    game.add.tween(this._activeWheel)
      .to({ y: this._activeWheel.y }, 500, Phaser.Easing.Circular.Out, true)
      .onComplete.add(() => {
        if (this.game === null) return;
        if (this._premium) {
          this._premiumSpinBtn.visible = true;
          this._premiumSpinBtn.alpha = 0;
          game.add.tween(this._premiumSpinBtn)
            .to({ alpha: 1 }, 600, Phaser.Easing.Sinusoidal.Out, true);
        } else {
          game.add.tween(this._freeStopBtn)
            .to({ alpha: 1 }, 300, Phaser.Easing.Sinusoidal.Out, true, 600)
            .onComplete.add(() => {
              if (this.game === null) return;
              this._freeStopBtn.currentState = BUTTONSTATE.ENABLED;
            }, this);

          game.time.events.add(400, () => {
            this._startSpinningWheel_Free();
          });
        }
      });
  }

  /**
   * init the prize wheel instance
   */
  _initWheel() {
    this._dailyGame = new SpinningWheel({
      prizeList: {
        current: G.Utils.clone(this._getPrizeTable(this._moreMoneyMode, false)),
        predeterminedPrize: -1,
      },
      premium: false,
      isFirstTimeSpinning: !G.saveState.data.firstTimeWheelSpinner,
      autoStart: false,
      moreMoneyMode: G.IAP ? true : this._moreMoneyMode,
    });
    this._dailyGame.y = 135;
  }

  _getPrizeTable(moreMoney, premium) {
    if (G.IAP) {
      return G.json['configs/spinWheels'].prizeWheelNormal;
    } else {
      if (moreMoney && premium) {
        return G.json['configs/spinWheels'].moreMoney;
      } else if (!moreMoney && premium) {
        return G.json['configs/spinWheels'].prizeWheelGold;
      } else {
        return G.json['configs/spinWheels'].prizeWheelNormal;
      }
    }
  }

  /**
   * init the prize wheel banner
   */
  _initPrizeBanner() {
    this._bannerGroup = new Phaser.Group(game, this);
    if (!G.IAP && !this._moreMoneyMode) {
      this._ribbonImg = G.makeImage(0, -113, G.OMTsettings.global.jungleMatch 
        ? 'gold_wheel_ribbon_nothing' : 'gold_wheel_ribbon', 0.5, this._bannerGroup);
      this._ribbonTxt = new G.Text(0, 0, OMT.language.getText('3x higher winnings!'), {
        style: 'font-white',
        fontSize: '50px',
      }, 0.5, 350);
      this._ribbonImg.addChild(this._ribbonTxt);
      this._ribbonImg.scale.setTo(0);
    }

    this._banner = G.makeImage(0, -190, 'green_wheel_ribbon', 0.5, this._bannerGroup);
    this._banner.scale.setTo(1.25);
    this._dailyTxt = new G.Text(0, -190, OMT.language.getText('Prize wheel'), {
      style: 'font-white',
      fontSize: '58px',
    }, 0.5, 400);
    this._bannerGroup.add(this._dailyTxt);
  }

  /**
   * init window buttons
   */
  _initButtons() {
    // close button
    this._closeButton = new G.Button(260, -190, 'btn_x', this._closeButtonPressed, this);
    this.registerButtons(this._closeButton);
    this._closeButton.visible = this._showCloseButtonInitially;

    // standard stop button
    this._freeStopBtn = new OMT_UI_SquareButton(0, 435, {
      button: {
        tint: BUTTONCOLOURS.green,
        dimensions: {
          width: 309,
          height: 100,
        },
        isEnabled: false,
      },
      text: {
        string: OMT.language.getText('Stop'),
        textStyle: {
          style: 'font-white',
          fontSize: 50,
        },
      },
      options: {
        clickFunction: {
          onClick: this._stopSpinningWheel_Free.bind(this),
        },
      },
    });
    this.add(this._freeStopBtn);
    this._freeStopBtn.visible = false;

    // alt spin button for more money mode
    const adImg = G.makeImage(0, 0, 'btn-movie-icon', 0.5, null);
    this._premiumSpinBtn = new OMT_UI_SquareButton(0, 435, {
      button: {
        tint: BUTTONCOLOURS.purple,
        dimensions: {
          width: 309,
          height: 100,
        },
      },
      text: {
        string: this._moreMoneyMode ? OMT.language.getText('Spin') : OMT.language.getText('Spin again'),
        textStyle: {
          style: 'font-white',
          fontSize: 50,
        },
        icon: {
          image: adImg,
          offset: {
            x: adImg.width / 2,
          },
          align: 'left',
        },
        offset: {
          x: adImg.width / 4,
        },
        dimensionMods: {
          height: 0.9,
          width: 0.65,
        },
      },
      options: {
        clickFunction: {
          onClick: this._showSpinWheelAd.bind(this),
        },
        cacheButton: false,
      },
    });
    this.add(this._premiumSpinBtn);
    this._premiumSpinBtn.visible = false;

    // alt stop button for more money mode
    this._premiumStopBtn = new OMT_UI_SquareButton(0, 435, {
      button: {
        tint: BUTTONCOLOURS.green,
        dimensions: {
          width: 309,
          height: 100,
        },
      },
      text: {
        string: OMT.language.getText('Stop'),
        textStyle: {
          style: 'font-white',
          fontSize: 49,
        },
      },
      options: {
        clickFunction: {
          onClick: this._stopSpinningWheel_Premium.bind(this),
        },
        cacheButton: false,
      },
    });
    this.add(this._premiumStopBtn);
    this._premiumStopBtn.visible = false;
  }

  /**
   * init the post spin / reward elements
   */
  _initPostSpinElements() {
    this._youWinTxt = new G.Text(0, 0, '', {
      style: 'font-white',
      fontSize: '60px',
    }, 0.5, 500);
    this.add(this._youWinTxt);
    this._youWinTxt.visible = false;

    this._claimButton = new OMT_UI_SquareButton(0, 435, {
      button: {
        tint: BUTTONCOLOURS.green,
        dimensions: {
          width: 309,
          height: 100,
        },
      },
      text: {
        string: OMT.language.getText('Claim'),
        textStyle: {
          style: 'font-white',
          fontSize: 50,
        },
      },
      options: {
        clickFunction: {
          onClick: this._claimBtnAction.bind(this),
        },
      },
    });
    this.registerButtons(this._claimButton);
    const tw = game.add.tween(this._claimButton).to({ alpha: 0 }, 150, Phaser.Easing.Sinusoidal.InOut, true);
    tw.onComplete.add(() => {
      this._claimButton.visible = false;
    });
  }

  /**
   * change to regular reward mode
   */
  _changeToRegular() {
    this._premium = false;
    if (this._ribbonImg && this._ribbonImg.scale.x > 0) {
      G.stopTweens(this._ribbonImg);
      game.add.tween(this._ribbonImg.scale).to({ x: 0, y: 0 }, 200, Phaser.Easing.Cubic.In, true);
    }
    this._activeWheel = this._dailyGame;
  }

  _makePremiumWheel() {
    this._dailyGamePremium = new SpinningWheel({
      prizeList: {
        current: G.Utils.clone(this._getPrizeTable(this._moreMoneyMode, true)),
        predeterminedPrize: -1,
      },
      premium: true,
      isFirstTimeSpinning: false,
      autoStart: false,
      moreMoneyMode: this._moreMoneyMode,
    });
    this._dailyGamePremium.y = this._dailyGame.y;
  }

  /**
   * change to premium reward mode
   */
  _changeToPremium(playAnimation) {
    if (!this._dailyGamePremium) {
      this._makePremiumWheel();
    }
    const clearDailyGame = () => {
      if (this._dailyGame) {
        if (this._dailyGame.parent) {
          this._dailyGame.parent.removeChild(this._dailyGame);
        }
        this._dailyGame.destroy();
        this._dailyGame = null;
      }
    };
    this._activeWheel = this._dailyGamePremium;
    this._premium = true;
    if (this._ribbonImg && this._ribbonImg.scale.x < 1) {
      G.stopTweens(this._ribbonImg);
      game.add.tween(this._ribbonImg.scale).to({ x: 1, y: 1 }, 500, Phaser.Easing.Elastic.Out, true);
    }
    if (playAnimation) {
      this._dailyGame.signals.collectWheelPrizeVisually.removeAll();
      this._attachListenersToWheel(this._dailyGamePremium);
      this._dailyGamePremium.fillWheel();
      const tempPos = this._dailyGame.x;
      this._dailyGamePremium.container.x = 1000;
      this.addChildAt(this._dailyGamePremium, this.getChildIndex(this._dailyGame));
      game.add.tween(this._dailyGamePremium.container)
        .to({ x: tempPos }, 600, Phaser.Easing.Circular.Out, true);
      const tw = game.add.tween(this._dailyGame.container)
        .to({ x: -1000 }, 300, Phaser.Easing.Sinusoidal.InOut, true);
      tw.onComplete.add(clearDailyGame, this);
    } else {
      clearDailyGame();
    }
  }

  _attachListenersToWheel(wheel) {
    wheel.signals.collectWheelPrizeVisually.add((prizeSnapshot) => {
      this._darkenWheel();
      this._showPrize(prizeSnapshot.current[prizeSnapshot.predeterminedPrize]);
    });
  }

  /**
   * start free wheel spin
   */
  _startSpinningWheel_Free() {
    this._activeWheel.startTheWheel();
  }

  /**
   * stop free wheel spin
   */
  async _stopSpinningWheel_Free() {
    this._freeStopBtn.visible = false;
    if (!this._moreMoneyMode) {
      OMT.platformTracking.logFTUEvent('FTUX_FirstSpinMade', null);
      OMT.platformTracking.logEvent(OMT.platformTracking.Events.AdWheelSpin, null);
    }

    this._activeWheel.spinState = this._activeWheel.SpinStates.Ready_To_Go;

    G.sb('wheelSpin').dispatch();
    if (!G.saveState.data.firstTimeWheelSpinner) {
      G.saveState.markWheelAsSpun(false);
    }
    this._closeButton.visible = false;

    if (!this._isAdFallback) {
      G.saveState.data.freeSpin = false;
      G.saveState.save();
    }
    this._premiumSpinBtn.visible = false;

    // Schedule game triggered message for next wheel spin, time in hours rounded up
    const secondsUntilNextFreeSpin = Math.ceil((24 * 60 * 60) - ((Date.now() - G.saveState.data.lastDaily) / 1000));
    await OMT.notifications.scheduleGameTriggeredMessage(OMT.envData.settings.user.userId, 'ResetWheel', secondsUntilNextFreeSpin, null);
  }

  /**
   * start spinning wheel premium
   */
  _startSpinningWheel_Premium() {
    this._activeWheel.startTheWheel();
    this._closeButton.visible = false;
    this._premiumSpinBtn.visible = false;
  }

  /**
   * stop spinning wheel premium
   */
  _stopSpinningWheel_Premium() {
    this._activeWheel.spinState = this._activeWheel.SpinStates.Ready_To_Go;
    OMT.platformTracking.logEvent(OMT.platformTracking.Events.AdMoreCoinsWheelSpin);

    G.sb('wheelSpin').dispatch();
    if (!G.saveState.data.firstTimeWheelSpinner) {
      G.saveState.markWheelAsSpun();
    }
    this._premiumStopBtn.visible = false;
  }

  /**
   * darken the wheel graphics
   */
  _darkenWheel() {
    this._activeWheel.darken();
  }

  /**
   * lighten the wheel graphics
   */
  _brightenWheel() {
    this._activeWheel.brighten();
  }

  /**
   * on ad successfully shown
   */
  _adSuccess() {
    this._startSpinningWheel_Premium();
    game.time.events.add(500, () => {
      this._premiumStopBtn.alpha = 0;
      this._premiumStopBtn.visible = true;
      game.add.tween(this._premiumStopBtn)
        .to({ alpha: 1 }, 600, Phaser.Easing.Sinusoidal.Out, true, 300);
    });
  }

  /**
   * show and ad for a wheel spin
   */
  _showSpinWheelAd() {
    if (this._moreMoneyMode) {
      OMT.platformTracking.logEvent(OMT.platformTracking.Events.AdMoreCoinsWheelSpin);
    } else {
      OMT.platformTracking.logFTUEvent('FTUX_FirstAdSpinMade', null);
      OMT.platformTracking.logEvent(OMT.platformTracking.Events.AdWheelSpin);
    }

    sdkHandler.trigger('rewardedAd', {
      callback:  (success) => {
        console.log("exito", success)
        if (success) { 
          this._adSuccess() ;
        }
        else {
          new Window_FillRateFallback(undefined, {
                    placement: G.BuildEnvironment.adPlacements.spinTheDailyWheel,
                    callback: this._adSuccess.bind(this),
                    onExit: () => {
                      this._premiumSpinBtn.visible = true;
                      this._closeButton.visible = true;
                    },
                    context: this,
                  });
          // this._premiumSpinBtn.visible = true;
          // this._closeButton.visible = true;
         }
      }
    }, this);
    // OMT.ads.showAd(
    //   G.BuildEnvironment.adPlacements.spinTheDailyWheel,
    //   this._adSuccess.bind(this),
    //   () => {
    //     if (!G.IAP) { // no IAPS dont use ad fallbacks
    //       // eslint-disable-next-line no-new
    //       new Window_FillRateFallback(undefined, {
    //         placement: G.BuildEnvironment.adPlacements.spinTheDailyWheel,
    //         callback: this._adSuccess.bind(this),
    //         onExit: () => {
    //           this._premiumSpinBtn.visible = true;
    //           this._closeButton.visible = true;
    //         },
    //         context: this,
    //       });
    //     } else { // open ad fallback
    //       OMT.ads.showAdFallback(this._adSuccess.bind(this));
    //     }
    //   },
    // );
  }

  /**
   * on close button pressed
   */
  _closeButtonPressed() {
    if (this._wonPrize) {
      OMT.transactionTracking.logInventoryTransactionBegin();

      this._applyGift(this._moreMoneyMode, this._wonPrize);
      this._wonPrize = null;

      OMT.transactionTracking.logInventoryTransactionEnd();
    }
    G.sb('showMainHighscorePanel').dispatch();
    this.closeWindow();
  }

  /**
   * on claim button clicked
   */
  _claimBtnAction() {
    if (this._wonPrize.prize.indexOf('booster') === 0) {
      G.sfx.line.play();
    } else if (this._wonPrize.prize.indexOf('coin') === 0) {
      G.sfx.chain_rattle.play();
    }
    this._applyPrize(this._wonPrize, false);
    this._wonPrize = false;
    this._claimButton.visible = false;
  }

  /**
   * show / animate in the users prize
   * @param {Array} prize
   */
  _showPrize(prize) {
    this._giftGroup.removeChildren();
    let winTxt = '';
    if (prize.prize.indexOf('coin') !== -1) {
      winTxt = OMT.language.getText('More Coins!');
    } else if (prize.prize.indexOf('booster') !== -1) {
      if (prize.amount > 1) {
        winTxt = OMT.language.getText('%#% Boosters').replace('%#%', prize.amount.toString());
      } else {
        winTxt = OMT.language.getText('1 Booster');
      }
    }
    this._youWinTxt.setText(winTxt);
    this._youWinTxt.scale.setTo(0);
    this._youWinTxt.visible = true;
    game.add.tween(this._youWinTxt.scale).to({ x: 1, y: 1 }, 600, Phaser.Easing.Elastic.Out, true);

    this._giftGfx = new G.LabelTextT(G.gift.getLabelString([prize.prize, prize.amount]), 0, 65, {
      style: 'font-num-blue',
      fontSize: '110px',
      scaleStroke: true,
    }, 0.5, 300);
    this._giftGfx.scale.setTo(0);

    game.add.tween(this._giftGfx.scale).to({ x: 1, y: 1 }, 600, Phaser.Easing.Elastic.Out, true);

    this._giftGroup.add(this._giftGfx);

    this._wonPrize = prize;

    game.time.events.add(1000, () => {
      this._claimButton.alpha = 1;
      this._claimButton.scale.setTo(0);
      game.add.tween(this._claimButton.scale).to({ x: 1, y: 1 }, 600, Phaser.Easing.Elastic.Out, true).onComplete.add(() => {
        if (this.game === null) return; // eslint-disable-line no-useless-return
      }, this);
      this._claimButton.visible = true;

      if (this._shareCheckbox) {
        this._shareCheckbox.visible = true;
        this._shareCheckbox.alpha = 0;
        game.add.tween(this._shareCheckbox).to({ alpha: 1 }, 600, Phaser.Easing.Elastic.Out, true).onComplete.add(() => {
          if (this.game === null) return;
          this._shareCheckbox.ignoreChildInput = false;
        }, this);
      }
    }, this);
  }

  /**
   * apply the prize and set the window to reset
   * @param {Array} prize
   */
  _applyPrize(prize) {
    OMT.transactionTracking.logInventoryTransactionBegin();
    this._wonPrize = null;

    const formattedGift = [prize.prize, prize.amount];
    if (prize.prize === 'coin' && this._worldState) {
      this.state.uiTargetParticles.createCoinBatch(
        game.world.bounds.x + this._giftGfx.worldPosition.x,
        this._giftGfx.worldPosition.y,
        this.state.panel.coinsTxt,
        prize.amount,
      );
      OMT.transactionTracking.addInventoryChange('coins', 0, prize.amount);
    } else {
      this._applyGift(this._moreMoneyMode, formattedGift);
    }

    OMT.transactionTracking.logInventoryTransactionEnd();
    DDNA.transactionHelper.trackRewards(formattedGift, [], {
      transactionType: 'REWARD',
      tActionType: 'WHEEL_SPIN',
      tGameArea: game.state.getCurrentState().key === 'Game' ? 'LEVEL' : 'MAP',
    });

    if (!this._isAdFallback) {
      game.time.events.add(1000, this._restart, this);
    } else { // for ad fallback we just exit
      this._isAdFallback = false;
      game.time.events.add(1000, this._restart, this);
      // G.sb("showMainHighscorePanel").dispatch();
      // this.closeWindow();
    }
  }

  /**
   * apply prize data to user inventory
   * @param {boolean} moreMoneyMode
   * @param {Array} gift
   */
  _applyGift(moreMoneyMode, gift) {
    if (moreMoneyMode) {
      G.gift.applyGift(
        gift,
        G.gift.ItemType.GetCoinsSpin,
        this._worldState ? G.gift.ItemId.Map : G.gift.ItemId.InGame,
      );
    } else {
      G.gift.applyGift(gift, G.gift.ItemType.Reward, G.gift.ItemId.DailyReward);
    }
  }

  /**
   * restart the prize wheel flow
   */
  _restart() {
    if (!game.incentivised()) {
      G.sb('showMainHighscorePanel').dispatch();
      this.closeWindow();
      return;
    }

    this._brightenWheel();

    if (this._shareCheckbox) {
      this._shareCheckbox.ignoreChildInput = true;
      game.add.tween(this._shareCheckbox).to({ alpha: 0 }, 300, Phaser.Easing.Sinusoidal.In, true);
    }

    game.add.tween(this._claimButton).to({ alpha: 0 }, 300, Phaser.Easing.Sinusoidal.In, true);

    this._premiumSpinBtn.visible = true;
    this._premiumSpinBtn.alpha = 0;
    game.add.tween(this._premiumSpinBtn).to({ alpha: 1 }, 300, Phaser.Easing.Sinusoidal.In, true);

    game.add.tween(this._activeWheel).to({ alpha: 1 }, 300, Phaser.Easing.Sinusoidal.InOut, true, 400).onComplete.add(() => {
      if (this.game === null) return;
      if (this._isAdFallback || (!this._moreMoneyMode && G.saveState.data.freeSpin)) {
        this._changeToRegular();
      } else {
        // eslint-disable-next-line no-lonely-if
        if (this._premium) {
          this._changeToPremium(false);
        } else {
          this._changeToPremium(true);
        }
      }
      this._closeButton.visible = true;
    }, this);

    game.add.tween(this._youWinTxt.scale).to({ x: 0, y: 0 }, 300, Phaser.Easing.Sinusoidal.InOut, true);

    game.add.tween(this._giftGroup).to({ alpha: 0 }, 300, Phaser.Easing.Sinusoidal.In, true).onComplete.add(() => {
      if (this.game === null) return;
      this._giftGroup.destroy();
      this._giftGroup = this.add(game.make.group());
      this._giftGroup.y = 80;
    }, this);
  }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.dailyWheel = Window_DailyWheel;
